(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["UploadSdk"] = factory();
	else
		root["UploadSdk"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(9)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_userAgent__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_ajax__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_reset_scss__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_reset_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_reset_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_iconfont_iconfont_css__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_iconfont_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_iconfont_iconfont_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'upload-sdk',
  data: function data() {
    return {
      imgList: [],
      XYUploadOption: false,
      isNeedle: false
    };
  },

  props: {
    action: {
      type: String,
      required: true
    },
    withCredentials: Boolean,
    headers: Object,
    limit: Number, // 上传数量限制
    onExceed: Function, // 超出数量限制的回调
    sizeLimit: Number, // 文件大小限制
    onExceedSize: Function, // 文件大小超过限制回调
    onSuccess: Function,
    onError: Function, // 错误回调
    srcList: Array, // 双向绑定上传后的array
    multiple: {
      type: Boolean,
      default: false
    },
    needle: Object,
    beforeUpload: Function,
    onAlllSuccess: Function,
    inlineLoading: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    deleteImg: function deleteImg(index) {
      this.imgList.splice(index, 1);
    },
    handleChange: function handleChange(e) {
      var files = e.target.files;
      if (files.length !== 0) {
        for (var i = 0; i < files.length; i++) {
          if (!this.validate(files[i], files)) return;
          this.uploadFile(files[i], files);
        }
      }
      this.$refs.$input.value = '';
    },
    XYUploadHandle: function XYUploadHandle(type) {
      var _this = this;

      this.XYUploadOption = false;
      this.needle.image.pick({ type: type }, function (error, _ref) {
        var base64 = _ref.base64;

        if (error) {
          if (_this.onError) {
            _this.onError(error);
          } else {
            throw new Error(error.message);
          }
        } else {
          var file = _this.base64ToFile(base64);
          if (!_this.validate(file, [file])) return;
          _this.uploadFile(file, [file]);
        }
      });
    },
    uploadFile: function uploadFile(file, filesList) {
      var _this2 = this;

      var copyFileList = [].concat(_toConsumableArray(filesList));
      if (this.beforeUpload) {
        this.beforeUpload(file, copyFileList);
      }
      var imageData = new FormData();
      imageData.append('file', file);
      var fileInfo = {
        'name': file.name ? file.name : Date.now() + '.png',
        'url': window.URL.createObjectURL(file),
        'isLoading': true
      };
      this.imgList.push(fileInfo);
      var lastIndex = this.imgList.length - 1;
      var options = {
        action: this.action,
        withCredentials: this.withCredentials,
        headers: this.headers,
        data: imageData
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__lib_ajax__["a" /* default */])(options).then(function (data) {
        _this2.imgList.splice(lastIndex, 1, _extends({}, fileInfo, {
          response: data
        }));
        _this2.imgList[lastIndex] = Object.assign(_this2.imgList[lastIndex], { 'isLoading': false });
        if (_this2.onSuccess) {
          _this2.onSuccess(data, file, copyFileList);
        }
      }, function (statusText) {
        if (_this2.onError) {
          _this2.onError(statusText, file, copyFileList);
        }
      });
    },
    validate: function validate(files, filesList) {
      // 如果没有
      if (!files) return false;
      // 验证个数
      if (this.limit && filesList.length + this.imgList.length > this.limit) {
        if (this.onExceed) {
          this.onExceed(files, filesList);
        } else {
          throw new Error('文件超过个数');
        }
        return false;
      }
      // 验证大小
      if (this.sizeLimit && files.size / 1024 / 1024 > this.sizeLimit) {
        if (this.onExceedSize) {
          this.onExceedSize(files, filesList);
        } else {
          throw new Error('文件超出大小限制');
        }
        return false;
      }
      return true;
    },
    showXYUploadOption: function showXYUploadOption() {
      this.XYUploadOption = true;
    },
    closeXyUpload: function closeXyUpload() {
      this.XYUploadOption = false;
    },
    base64ToFile: function base64ToFile(urlData) {
      try {
        // 转换为byte
        var bytes = window.atob(urlData);
        var bufferData = new window['ArrayBuffer'](bytes.length);
        var UintData = new window['Uint8Array'](bufferData);
        for (var i = 0; i < bytes.length; i++) {
          UintData[i] = bytes.charCodeAt(i);
        }
        var blobData = new Blob([UintData], { type: 'image/png' });
        return blobData;
      } catch (e) {
        alert('blob error');
      }
    },
    compareVersion: function (_compareVersion) {
      function compareVersion(_x, _x2) {
        return _compareVersion.apply(this, arguments);
      }

      compareVersion.toString = function () {
        return _compareVersion.toString();
      };

      return compareVersion;
    }(function (v1, v2) {
      var _v1 = v1.split('.'),
          _v2 = v2.split('.'),
          _r = _v1[0] - _v2[0];
      return _r == 0 && v1 != v2 ? compareVersion(_v1.splice(1).join('.'), _v2.splice(1).join('.')) : _r;
    })
  },
  mounted: function mounted() {
    // needle低于‘0.2.5并且是安卓使用SDK’
    if ((__WEBPACK_IMPORTED_MODULE_0__lib_userAgent__["a" /* default */].isXY() || __WEBPACK_IMPORTED_MODULE_0__lib_userAgent__["a" /* default */].isNapos()) && this.needle && __WEBPACK_IMPORTED_MODULE_0__lib_userAgent__["a" /* default */].isAndroid()) {
      this.needle.app.getEnvInfo(function (err, res) {
        if (err) {
          if (this.onError) {
            this.onError(err);
          } else {
            throw new Error('needle error');
          }
        } else {
          // 比较版本号
          if (this.compareVersion('0.2.5', res.sdkVersion) > 0) {
            this.isNeedle = true;
          }
        }
      });
    }
  },

  watch: {
    imgList: function imgList(newValue) {
      this.$emit('update:srcList', newValue);
    },

    srcList: {
      handler: function handler(val) {
        if (!val) {
          return;
        }
        this.imgList = val || [];
      },

      immediate: true
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "iconfont.eot?4589386673d16f4793576cd7eef287f5";

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__upload_vue__ = __webpack_require__(6);

console.log(1);
var UploadSdk = {};

UploadSdk.install = function (Vue, options) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__upload_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__upload_vue__["a" /* default */]);
};

var Component = __WEBPACK_IMPORTED_MODULE_0__upload_vue__["a" /* default */];

/* harmony default export */ __webpack_exports__["default"] = (UploadSdk);

// Auto-install
var GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(UploadSdk);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),
/* 5 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_602f5294_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_vue__ = __webpack_require__(20);
function injectStyle (ssrContext) {
  __webpack_require__(7)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-602f5294"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_602f5294_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(8);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("245a7d2a", content, true);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".upload .img-list[data-v-602f5294],.upload[data-v-602f5294]{width:100%}.upload .img-list li[data-v-602f5294]{width:23.5%;margin-right:2%;margin-bottom:.3rem;height:0;float:left;position:relative;padding:11.75% 0}.upload .img-list li .img-item-wapper[data-v-602f5294]{position:absolute;left:0;top:0;width:100%;height:100%}.upload .img-list li sub[data-v-602f5294]{position:absolute;right:-10px;top:-10px;background:#fa5555;width:20px;line-height:20px;font-size:12px;color:#fff;text-align:center;border-radius:50%;z-index:9997}.upload .img-list li .img-item[data-v-602f5294]{width:100%;height:100%;background-size:cover}.upload .img-list li img[data-v-602f5294]{width:100%;height:100%}@keyframes rotation-data-v-602f5294{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.upload .img-list li .loading[data-v-602f5294]{width:100%;height:100%}.upload .img-list li .loading i[data-v-602f5294]{width:100%;height:100%;display:flex;align-items:center;justify-content:center;animation:rotation-data-v-602f5294 1s linear infinite;color:#ccc;font-size:36px}.upload .img-list li .loading i[data-v-602f5294]:before{display:inline-block;vertical-align:sub}.upload .img-list li[data-v-602f5294]:nth-of-type(4n){margin:0}.upload .img-list .upload-button[data-v-602f5294]{position:relative;border:1px dashed #d8dce5;background:#f7f9fc}.upload .img-list .upload-button .input-wapper[data-v-602f5294],.upload .img-list .upload-button .XYUploadBtn[data-v-602f5294]{display:block;width:100%;height:100%;position:absolute;visibility:0;top:0;left:0;opacity:0;z-index:999}.upload .img-list .upload-button input[data-v-602f5294]{display:block;width:100%;height:100%}.upload .img-list .upload-button i[data-v-602f5294]{display:inline-block;width:100%;font-size:38px;text-align:center;color:#d8dce5;height:100%}.upload .img-list .upload-button i[data-v-602f5294]:before{vertical-align:text-bottom;display:inline-block;width:100%;position:relative;top:18px}.xy-upload-toast[data-v-602f5294]{width:100%}.xy-upload-toast .mask[data-v-602f5294]{position:fixed;top:0;left:0;height:100%;width:100%;background:hsla(0,0%,58%,.6);z-index:9998}.xy-upload-toast .upload-option-container[data-v-602f5294]{position:fixed;bottom:0;left:0;width:100%;z-index:9999;padding:0 1.5%}.xy-upload-toast .upload-option-container ul[data-v-602f5294]{background:#fff;border-radius:8px;margin-bottom:20px}.xy-upload-toast .upload-option-container ul li[data-v-602f5294]{line-height:120px;padding:0 24px;border-bottom:1px solid #f0f0f0}.xy-upload-toast .upload-option-container ul li span[data-v-602f5294]{font-size:36px}.xy-upload-toast .upload-option-container ul li i[data-v-602f5294]{display:inline-block;width:18px;height:18px;float:right;color:#26a2ff;font-size:38px;margin-right:24px}.xy-upload-toast .upload-option-container ul li[data-v-602f5294]:last-of-type{border:0}.xy-upload-toast .upload-option-container .cancel[data-v-602f5294]{font-size:36px;line-height:120px;padding:0 24px;background:#fff;border-radius:8px;text-align:center;color:#26a2ff;margin-bottom:24px}.fade-in-enter-active[data-v-602f5294],.fade-in-leave-active[data-v-602f5294]{transition:all .5s cubic-bezier(.55,0,.1,1)}.fade-in-enter[data-v-602f5294],.fade-in-leave-active[data-v-602f5294]{opacity:0}.clear-float[data-v-602f5294]:after{clear:both;content:\"\";height:0;display:block}", ""]);

// exports


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 10 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  checkClient: function checkClient() {
    var UA = navigator.userAgent;
    var rajax = /Rajax/i;
    var isXY = /EVE|Needle/i;
    var isQS = /QS|hbdteam/i;
    var isNapos = /Napos/i;
    var wechat = /MicroMessenger/i;
    var isIos = /iphone/i;
    var isIpad = /ios/i;
    var isAndroid = /android/i;

    if (wechat.test(UA)) return 'wechat';
    if (isXY.test(UA) && !rajax.test(UA)) return 'isXY';
    if (isQS.test(UA)) return 'isQS';
    if (isNapos.test(UA) && rajax.test(UA)) return 'isNapos';
    if (isIos.test(UA) || isIpad.test(UA)) return 'ios';
    if (isAndroid.test(UA)) return 'android';
    if (!isXY.test(UA)) return 'browser';
  },
  isXY: function isXY() {
    return this.checkClient() === 'isXY';
  },
  isQS: function isQS() {
    return this.checkClient() === 'isQS';
  },
  isNapos: function isNapos() {
    return this.checkClient() === 'isNapos';
  },
  isAndroid: function isAndroid() {
    return this.checkClient() === 'android';
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ajax;
/**
* @param {Object} options
* @param {boolean} [options.withCredentials]
* @param {string} [options.action]
* @param {Object} [options.header]
*/

function ajax(options) {
  return new Promise(function (res, rej) {
    if (typeof XMLHttpRequest === 'undefined') {
      return;
    }
    var xhr = new XMLHttpRequest();
    var action = options.action;
    xhr.open('post', action, true);
    if (options.withCredentials && 'withCredentials' in xhr) {
      xhr.withCredentials = true;
    }
    var headers = options.headers || {};

    for (var item in headers) {
      if (headers.hasOwnProperty(item) && headers[item] !== null) {
        xhr.setRequestHeader(item, headers[item]);
      }
    }

    xhr.onload = function () {
      if (xhr.status < 200 || xhr.status >= 300) {
        rej(xhr.statusText);
        return;
      }
      res(JSON.parse(xhr.responseText));
    };
    xhr.onerror = function () {
      return rej(xhr.statusText);
    };
    xhr.send(options.data);
  });
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(14);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("50f3b8a8", content, true);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,html,i,iframe,img,input,ins,kbd,label,legend,li,main,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font-size:14px;font-weight:400;vertical-align:baseline;box-sizing:border-box}body{line-height:1}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:none}table{border-collapse:collapse;border-spacing:0}a{color:#7e8c8d;text-decoration:none;-webkit-backface-visibility:hidden}li{list-style:none}::-webkit-scrollbar{width:5px;height:5px}::-webkit-scrollbar-track-piece{background-color:rgba(0,0,0,.2);-webkit-border-radius:6px}::-webkit-scrollbar-thumb:vertical{height:5px;background-color:hsla(0,0%,49%,.7);-webkit-border-radius:6px}::-webkit-scrollbar-thumb:horizontal{width:5px;background-color:hsla(0,0%,49%,.7);-webkit-border-radius:6px}body,html{width:100%}body{-webkit-text-size-adjust:none;-webkit-tap-highlight-color:transparent}", ""]);

// exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(16);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4b7b8198", content, true);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(17);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "@font-face{font-family:iconfont;src:url(" + escape(__webpack_require__(3)) + ");src:url(" + escape(__webpack_require__(3)) + "#iefix) format(\"embedded-opentype\"),url(\"data:application/x-font-woff;charset=utf-8;base64,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\") format(\"woff\"),url(" + escape(__webpack_require__(18)) + ") format(\"truetype\"),url(" + escape(__webpack_require__(19)) + "#iconfont) format(\"svg\")}.iconfont{font-family:iconfont!important;font-size:16px;font-style:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-loading:before{content:\"\\E62E\"}.icon-plus:before{content:\"\\E82F\"}.icon-camera:before{content:\"\\E653\"}.icon-delete:before{content:\"\\E60E\"}.icon-photo:before{content:\"\\E602\"}", ""]);

// exports


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "iconfont.ttf?318303f3626f8be22a20527e55597d29";

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "iconfont.svg?f5c99a1515aedeef0f5e9b6207b2825f";

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload"},[_c('ul',{staticClass:"img-list clear-float"},[_vm._l((_vm.imgList),function(img,index){return _c('li',[_c('div',{staticClass:"img-item-wapper"},[(img.isLoading && _vm.inlineLoading)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"iconfont icon-loading"})]):_vm._e(),_vm._v(" "),(_vm.inlineLoading ? !img.isLoading:true)?_c('div',{staticClass:"img-item",style:(("background-image:url(" + (img.url) + ")"))}):_vm._e(),_vm._v(" "),(_vm.inlineLoading ? !img.isLoading:true)?_c('sub',{staticClass:"iconfont icon-delete",on:{"click":function($event){_vm.deleteImg(index)}}}):_vm._e()])])}),_vm._v(" "),(_vm.imgList.length !== this.limit)?_c('li',{staticClass:"upload-button"},[_c('div',{staticClass:"img-item-wapper"},[(_vm.isNeedle)?_c('div',{staticClass:"XYUploadBtn",on:{"click":_vm.showXYUploadOption}}):_c('div',{staticClass:"input-wapper"},[(_vm.multiple)?_c('input',{ref:"$input",attrs:{"type":"file","accept":"image/*","multiple":""},on:{"change":_vm.handleChange}}):_c('input',{ref:"$input",attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.handleChange}})]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-plus"})])]):_vm._e()],2),_vm._v(" "),_c('transition',{attrs:{"name":"fade-in"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.XYUploadOption),expression:"this.XYUploadOption"}],staticClass:"xy-upload-toast"},[_c('div',{staticClass:"mask",on:{"click":_vm.closeXyUpload}}),_vm._v(" "),_c('div',{staticClass:"upload-option-container"},[_c('ul',[_c('li',{on:{"click":function($event){_vm.XYUploadHandle('camera')}}},[_c('span',[_vm._v("拍照")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-camera"})]),_vm._v(" "),_c('li',{on:{"click":function($event){_vm.XYUploadHandle('album')}}},[_c('span',[_vm._v("\n              照片\n            ")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-photo"})])]),_vm._v(" "),_c('div',{staticClass:"cancel",on:{"click":_vm.closeXyUpload}},[_vm._v("\n          取消\n        ")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// upload-sdk.umd.js